const OperationTraceIdMap: {
	[operationName: string]: string[] | undefined;
} = {};

export const startCapturingTraceIds = (operationName: string) => {
	OperationTraceIdMap[operationName] = OperationTraceIdMap[operationName] || [];
};
export const stopCapturingTraceIds = (operationName: string) => {
	OperationTraceIdMap[operationName] = undefined;
};
export const addTraceId = (operationName: string, traceId?: string) => {
	if (traceId !== undefined) {
		const traceIdsForOperation = OperationTraceIdMap[operationName];
		if (traceIdsForOperation !== undefined) {
			traceIdsForOperation.push(traceId);
		}
	}
};

export const getTraceIds = (operationName: string) => OperationTraceIdMap[operationName] || [];
